import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaTasks, FaUsers } from 'react-icons/fa';

function MissionsNav() {
  const location = useLocation();
  const path = location.pathname;

  const isMissionsActive = () => {
    if (path.startsWith('/admin/missions/participants')) return false;
    return (
      path === '/admin/missions' ||
      path === '/admin/missions/' ||
      path.startsWith('/admin/missions/new') ||
      /^\/admin\/missions\/\d+/.test(path)
    );
  };

  const isParticipantsActive = () => path.startsWith('/admin/missions/participants');

  return (
    <Nav className="mb-4 border-bottom" style={{ padding: '10px 0' }}>
      <Nav.Item>
        <Button
          as={Link}
          to="/admin/missions"
          variant={isMissionsActive() ? 'primary' : 'outline-primary'}
          className="me-2"
        >
          <FaTasks className="me-2" />
          Missions
        </Button>
      </Nav.Item>
      <Nav.Item>
        <Button
          as={Link}
          to="/admin/missions/participants"
          variant={isParticipantsActive() ? 'primary' : 'outline-primary'}
          className="me-2"
        >
          <FaUsers className="me-2" />
          Participants
        </Button>
      </Nav.Item>
    </Nav>
  );
}

export default MissionsNav;
